export const validateCEP = (value: string): boolean => {
  if (!value) return false;

  // Remove formatação (pontos, hífens, espaços, letras)
  const digits = value.replace(/\D/g, '');
  
  // Valida se possui exatamente 8 dígitos
  return digits.length === 8;
};

export const validatePhone = (value: string): boolean => {
  if (!value) return false;

  // Remove parênteses, espaços, hífens, etc
  const digits = value.replace(/\D/g, '');

  // Regra 1: Deve ter 10 ou 11 dígitos
  if (digits.length !== 10 && digits.length !== 11) return false;

  // Regra 2: Validar o DDD (entre 11 e 99)
  const ddd = parseInt(digits.substring(0, 2), 10);
  if (ddd < 11 || ddd > 99) return false;

  // Regra 3: Celulares (11 dígitos) DEVEM começar com 9 logo após o DDD
  if (digits.length === 11) {
    if (digits[2] !== '9') return false;
  }
  
  // Regra 4: Fixo (10 dígitos) normalmente não começa com 9
  if (digits.length === 10) {
    if (digits[2] === '9') return false; 
  }

  return true;
};
